import { Popover } from 'shared'

export const TaxDeductibilityNotice = () => {
  return <div className='donations-form-tax-deductibility'>
    <Popover
      trigger={<span className='simulated-link'>{I18n.t('donate.iframe.tax_deductibility_notice')}</span>}
      popover={I18n.t('donate.iframe.tax_deductibility_notice_popover')}
    />
  </div>
}
